import { FONT_OPTIONS } from './designConstants';
import { DesignSettings, SectionSaveState } from './designTypes';
import { SaveButton } from './DesignShared';

interface Props {
  design: DesignSettings;
  updateDesign: (patch: Partial<DesignSettings>) => void;
  fontSaveState: SectionSaveState;
  onSaveFont: () => void;
}

export default function TypographySection({ design, updateDesign, fontSaveState, onSaveFont }: Props) {
  return (
    <div className="flex flex-col gap-5">
      <div className="bg-gray-50 rounded-2xl p-5 border border-gray-100">
        <h3 className="text-sm font-bold text-[#1a1a1a] mb-1 flex items-center gap-2">
          <div className="w-6 h-6 flex items-center justify-center bg-[#1a1a1a] rounded-lg">
            <i className="ri-text text-white text-[10px]"></i>
          </div>
          خط الموقع
        </h3>
        <p className="text-xs text-gray-400 mb-4">اختر الخط الذي يناسب هوية متجرك</p>
        <div className="flex flex-col gap-3">
          {FONT_OPTIONS.map(font => (
            <button
              key={font.id}
              onClick={() => updateDesign({ fontId: font.id })}
              className={`flex items-center justify-between p-4 rounded-xl border-2 transition-all cursor-pointer text-right ${
                design.fontId === font.id ? 'border-[#1a1a1a] bg-white' : 'border-gray-100 bg-white hover:border-gray-300'
              }`}
            >
              <div className="flex flex-col gap-1">
                <span className="text-xl font-bold text-[#1a1a1a]" style={{ fontFamily: font.css }}>{font.sample}</span>
                <span className="text-xs text-gray-400">{font.label} · {font.name}</span>
              </div>
              {design.fontId === font.id && (
                <div className="w-6 h-6 flex items-center justify-center bg-[#1a1a1a] rounded-full flex-shrink-0">
                  <i className="ri-check-line text-white text-xs"></i>
                </div>
              )}
            </button>
          ))}
        </div>
        <SaveButton state={fontSaveState} onClick={onSaveFont} label="حفظ الخط" />
      </div>
    </div>
  );
}
